<template>
  <div ref="observerElement">
    <video
      ref="videoElement"
      class="video-js"
      preload="metadata"
      width="640"
      height="264"
      playsinline
      muted
    >
      <source
        :src="source"
        type="application/x-mpegURL"
      >
    </video>
    <div
      v-if="showError"
      class="video-error"
    >
      <b-img
        src="@/assets/images/icons/no-cctv.png"
        alt="Error image"
        style="width: 400px;"
      > ถ้ามีภาพ
      </b-img>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import videojs from 'video.js'
import {
  BImg,
} from 'bootstrap-vue'
// eslint-disable-next-line import/no-extraneous-dependencies
require('video.js/dist/video-js.css')

export default {
  components: {
    BImg,
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['source', 'index'],
  data() {
    return {
      observer: null,
      showError: false,
      retryTimeout: null,
      retryAttempted: false, // Added missing property
    }
  },
  mounted() {
    this.initializePlayer()
    this.setupIntersectionObserver()
    // Play the first four videos immediately
    if (this.index < 4) {
      this.player.play().catch(error => console.log(error))
    }
  },
  beforeDestroy() {
    this.disposePlayer()
    if (this.observer) {
      this.observer.disconnect()
    }
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout)
    }
  },
  methods: {
    initializePlayer() {
      this.player = videojs(this.$refs.videoElement, {
        html5: {
          hls: {
            smoothQualityChange: true,
            maxBufferLength: 30,
            maxBufferSize: 60 * 1000 * 1000, // 60MB
          },
        },
      }, () => {
        this.player.on('error', this.handleError)
      })
    },
    disposePlayer() {
      if (this.player) {
        this.player.off('error', this.handleError)
        this.player.dispose()
      }
    },
    handleError() {
      if (!this.retryAttempted) {
        this.retryAttempted = true
        this.showError = true
        // ลองเชื่อมต่ออีกครั้งหลังจาก 5 วินาที
        this.retryTimeout = setTimeout(() => {
          this.showError = false
          this.player.src({ type: 'application/x-mpegURL', src: this.source })
          this.player.load()
          this.player.play().catch(error => console.log(error))
        }, 5000)
      } else {
        console.log('การ retry ล้มเหลว', this.source)
      }
    },
    setupIntersectionObserver() {
      const options = {
        root: null,
        threshold: 0.5,
      }
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.player.play().catch(error => console.log(error))
          } else {
            this.player.pause().catch(error => console.log(error))
            this.player.buffered().end(0) // หยุดการ buffering
            this.player.dispose() // ทำลาย player เพื่อหยุดทุกการทำงาน
          }
        })
      }, options)
      this.observer.observe(this.$refs.observerElement)
    },
  },
}
</script>

<style scoped>
.video-js {
  width: 100%;
}
.video-error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
}
.video-error img {
  max-width: 30%;
  width: 50%;
  height: 35%;
  z-index: 1;
}
</style>
